import type { PublisherStats } from '@planuze/admin-contracts';
import { usePublishersContent } from '../../content/sections/publishers.js';
import { fmtDurationMs } from '../../lib/format.js';

/* Célula de stats de moderação por publisher (ADR-0471). Deriva da fila de review
   (GROUP BY publisherId). `null` = publisher sem submissões. */

const PERCENT = 100;

export function PublisherStatsCell({
  stats,
}: {
  readonly stats: PublisherStats | null | undefined;
}) {
  const copy = usePublishersContent();
  if (stats === null || stats === undefined || stats.totalSubmissions === 0) {
    return <span className="text-xs text-muted-foreground">{copy.statsCell.noSubmissions}</span>;
  }
  const avgLabel = stats.avgReviewMs === null ? null : fmtDurationMs(stats.avgReviewMs);
  return (
    <div className="text-xs text-muted-foreground">
      <div className="text-foreground">
        {copy.statsCell.summaryLine(stats.totalSubmissions, stats.pendingSubmissions)}
      </div>
      <div>{copy.statsCell.rejectionLine(Math.round(stats.rejectionRate * PERCENT), avgLabel)}</div>
    </div>
  );
}
